import { render, staticRenderFns } from "./ProcessInstanceTabs.vue?vue&type=template&id=973d972c&scoped=true"
import script from "./ProcessInstanceTabs.vue?vue&type=script&lang=js"
export * from "./ProcessInstanceTabs.vue?vue&type=script&lang=js"
import style0 from "./ProcessInstanceTabs.vue?vue&type=style&index=0&id=973d972c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973d972c",
  null
  
)

export default component.exports